(function () {
  'use strict';
  function init(scene) {
    if (scene._ogRiserCleanup || !scene.showcaseSelect) return;
    var images = scene.querySelectorAll('[data-showcase-slide]');
    if (images.length < 2) return;
    var frame = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function update() {
      frame = 0;
      if (!scene.closest('[data-product-showcase]')?.open) return;
      var travel = Math.max(scene.offsetHeight - window.innerHeight, 1);
      var progress = Math.min(1, Math.max(0, -scene.getBoundingClientRect().top / travel));
      scene.showcaseSelect(Math.round(progress * (images.length - 1)));
      scene.style.setProperty('--og-riser-progress', progress.toFixed(4));
      var bar = scene.querySelector('[data-og-riser-progress]');
      if (bar) bar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
    }
    function requestUpdate() { if (!frame) frame = requestAnimationFrame(update); }
    function onChoose(event) {
      if (event.target !== scene) return;
      var travel = Math.max(scene.offsetHeight - window.innerHeight, 1);
      window.scrollTo({ top: scene.getBoundingClientRect().top + window.scrollY + event.detail.index / (images.length - 1) * travel, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
    var disclosure = scene.closest('[data-product-showcase]');
    disclosure.addEventListener('showcase:expanded', requestUpdate);
    scene.addEventListener('showcase:choose', onChoose);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    scene._ogRiserCleanup = function () {
      cancelAnimationFrame(frame);
      disclosure.removeEventListener('showcase:expanded', requestUpdate);
      scene.removeEventListener('showcase:choose', onChoose);
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      delete scene._ogRiserCleanup;
    };
    requestUpdate();
  }
  function scan(root) { root.querySelectorAll('[data-og-riser-scroll]').forEach(init); }
  scan(document);
  document.addEventListener('DOMContentLoaded', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-og-riser-scroll]').forEach(function (scene) { scene._ogRiserCleanup?.(); });
  });
})();
